import { render, staticRenderFns } from "./DealRtaTable.vue?vue&type=template&id=2ad7a180&"
import script from "./DealRtaTable.vue?vue&type=script&lang=js&"
export * from "./DealRtaTable.vue?vue&type=script&lang=js&"
import style0 from "./DealRtaTable.vue?vue&type=style&index=0&id=2ad7a180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports